import { render } from "./MainProductOffers.vue?vue&type=template&id=6b5d7bbc"
import script from "./MainProductOffers.vue?vue&type=script&lang=js"
export * from "./MainProductOffers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__